import {useCallback, useEffect, useState} from "react"
import {makeStyles} from '@material-ui/core/styles';
import {Box, Button} from "@material-ui/core";
import DownIcon from '@material-ui/icons/KeyboardArrowDown';
import RightIcon from '@material-ui/icons/KeyboardArrowRight';
import Collapse from '@material-ui/core/Collapse';
import {CreatorClipTableBody} from "../../../atoms/tables/dashboardClipTableBody";
import {CreatorTableSubBody} from "../../../atoms/tables/dashboardTableSubBody";
import {CreatorTableHeader} from "../../../atoms/tables/dashboardTableHeader";
import {
  CREATOR_CLIP_TABLE_SUBHEADER,
  CREATOR_TABLE_HEADER,
  CREATOR_TABLE_HEADER_WITH_USER,
  CREATOR_TABLE_SUBHEADER,
  PAGINATION_PER_PAGE_ITEM,
  SESSION_SMALL_THUMBNAIL
} from '../../../../config/mock';
import {v4 as uuidv4} from 'uuid';
import {CreatorTableBody} from "../../../atoms/tables/dashboardTableBody";
import {useDispatch, useSelector} from 'react-redux';
import {updateSpecialProject} from "../../../../store/actions/creator/creatorExperienceManager";
import {
  searchExperience,
  updateSearchClipPage,
  updateSearchSessionPage
} from '../../../../store/actions/experience/experience';
import UtilService from '../../../../helper/service';
import clsx from 'clsx';
import {Loading} from '../../../atoms/commonLoadings';

const useStyles = makeStyles(() => ({
  container: {
    margin: '20px 105px 0px',
    height: 'calc(100vh - 210px)',
    overflow: 'auto',
    paddingTop: 10,
    '@media (max-width: 1025px)': {
      margin: 0,
    },
  },
  title: {
    color: '#697683',
    fontFamily: 'Spartan-bold',
    fontSize: 24
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#212D40',
    fontFamily: 'roboto-bold',
    fontSize: 16,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  card: {
    boxShadow: '0px 0px 4px #00000033',
    borderRadius: 10,
    background: '#fff',
    padding: '11px 66px 22px',
  },
  subcard: {
    // boxShadow: '0px 0px 4px #00000033',
    borderRadius: 10,
    // background: '#fff'
  },
  project: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    color: '#606B76',
    fontSize: 14,
    fontFamily: 'roboto-bold',
    marginTop: 12
  },
  name: {
    marginLeft: 8
  },
  bgfff: {
    background: '#fff'
  },
  bg: {
    background: '#F2F7FC!important',
  },
  borderRadius10: {
    borderRadius: 10,
    boxShadow: '0px 0px 4px #00000033',
  },
  borderRadiusBottom: {
    borderRadius: '0px 0px 10px 10px'
  },
  loadMoreDiv: {
    textAlign: 'center',
    marginBottom: 5,
    marginTop: 10,
  },
  loadMoreBtn: {
    padding: '6px 20px',
    background: '#017AEF',
    marginTop: 0,
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    textTransform: 'none',
  },
}));

function CreatorResult(props: any) {
  const classes = useStyles();
  const {
    userColumn, onSelectAllExperiences, onSelectAllClips, onChangeSelected, selected, onClearExperiences, onClearClips
  } = props;

  const {
    searchText, searchUsers, searchKey, searchSessionPage, searchClipPage, is_loading, sort_column_value, sort_direction
  } = useSelector((state: any) => state.experience);
  const search_sort_request= localStorage.getItem("search_sort_request") ? JSON.parse(localStorage.getItem("search_sort_request") || "{}") : "";
  const dispatch = useDispatch();
  const [project, setProject] = useState(true);
  const [experience, setExperience] = useState(true);
  const [clip, setClip] = useState(true);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [open, setOpen] = useState<number>(-1);
  const [experiences, setExperiences] = useState<any[]>([]);
  const [projects, setProjects] = useState([]);
  const [clips, setClips] = useState<any[]>([]);
  const [newSessionPage, setNewSessionPage] = useState(1);
  const [newClipPage, setNewClipPage] = useState(1);
  const [initialHover, setInitialHover] = useState<any>('');
  const [clipRowHover, setClipRowHover] = useState<any>('');
  const [allExpChecked, setAllExpChecked] = useState(false);
  const [allClipsChecked, setAllClipsChecked] = useState(false);
  
  useEffect(() => {
    if (searchKey) {
      if (searchKey.projects) {
        setProjects(searchKey.projects);
      }
      if (searchKey.sessions) {
        onSetVariables(searchKey.sessions)
      }
      if (searchKey.clips) {
        onSetClipsVariables(searchKey.clips)
      }
    }
  }, [searchKey]);

  useEffect(() => {
    if (selected.length === 0) {
      setAllExpChecked(false);
      setAllClipsChecked(false);
    }

    const selectedExperiences = selected.filter((s: any) => {
      if (s && !s.hasOwnProperty('clip_id')) {
        return s
      }
    });
    if (selectedExperiences.length === experiences.length) {
      setAllExpChecked(true);
    } else  {
      setAllExpChecked(false);
    }

    const selectedClips = selected.filter((s: any) => {
      if (s && s.hasOwnProperty('clip_id')) {
        return s
      }
    });
    if (selectedClips.length === clips.length) {
      setAllClipsChecked(true);
    } else {
      setAllClipsChecked(false);
    }
  }, [selected, experiences, clips]);

  const onSetClipsVariables = (data: any[]) => {
    const addClips: any = (newClipPage === 1) ? [] : [...clips];
    data.forEach((row: any) => {
      const mod_length = UtilService.convertSecondsToHHMMSS(
        Number(row.end_clip) - Number(row.start_clip)
      );
      const mod_start = Number(row.start_clip);
      const mod_end = Number(row.end_clip);

      const async_length = UtilService.convertSecondsToHHMMSS(
        UtilService.getSecondsFromHHMMSS(row.end_clip) - UtilService.getSecondsFromHHMMSS(row.start_clip)
      );
      const async_start = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(row.start_clip));
      const async_end = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(row.end_clip));

      const objectData: any = {
        clip_id: row.clip_id,
        session_id: 'clip-' + uuidv4(),
        clipList: true,
        session_code: row.session_code,
        session_type: row.session_type,
        session_title: row.session_title,
        session_status: row.session_status,
        session_category: row.session_category,
        session_subcategory: row.session_subcategory,
        img: SESSION_SMALL_THUMBNAIL,
        name: row.title ? row.title : '-',
        immersion: row.immersion_index ? row.immersion_index : '-',
        safety: row.safety_index ? row.safety_index : '-',
        length: row.session_type === 'ASYNC' ? async_length : mod_length,
        start: row.session_type === 'ASYNC' ? async_start : mod_start,
        end: row.session_type === 'ASYNC' ? async_end : mod_end,
        safety_tier_indicator: row.safety_tier_indicator,
        safety_color_indicator: row.safety_color_indicator,
        safety_context_indicator: row.safety_context_indicator,
        immersion_color_indicator: row.immersion_color_indicator,
        immersion_context_indicator: row.immersion_context_indicator,
        immersion_tier_indicator: row.immersion_tier_indicator,
      };

      if (!addClips.find((val: any) => (val.clip_id === row.clip_id && val.session_code === row.session_code))) {
        addClips.push(objectData)
      } else {
        let index: any = '';
        for (let j = 0; j < addClips.length; j++) {
          if (addClips[j].clip_id === row.clip_id && addClips[j].session_code === row.session_code) {
            index = j;
          }
        }
        if (index !== '') {
          addClips[index] = objectData;
        }
      }
      return objectData;
    });
    setClips(addClips);
  };

  const onSetVariables = (data: any[]) => {
    const addExperience: any = (newSessionPage === 1) ? [] : [...experiences];
    data.forEach((row: any) => {
      const clips = [];
      if (row.stimulus_clips && row.stimulus_clips.length > 0) {
        const clipList = row.stimulus_clips;
        for (let i = 0; i < row.stimulus_clips.length; i++) {
          const mod_length = UtilService.convertSecondsToHHMMSS(
            Number(clipList[i].end_clip) - Number(clipList[i].start_clip)
          );
          const mod_start = Number(clipList[i].start_clip);
          const mod_end = Number(clipList[i].end_clip);

          const async_length = UtilService.convertSecondsToHHMMSS(
            UtilService.getSecondsFromHHMMSS(clipList[i].end_clip) - UtilService.getSecondsFromHHMMSS(clipList[i].start_clip)
          );
          const async_start = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(clipList[i].start_clip));
          const async_end = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(clipList[i].end_clip));

          clips.push({
            session_id: 'clip-' + uuidv4(),
            session_code: row.session_code,
            session_type: row.session_type,
            session_title: row.session_title,
            session_status: row.session_status,
            session_category: row.session_category,
            session_subcategory: row.session_subcategory,
            img: SESSION_SMALL_THUMBNAIL,
            name: clipList[i].title ? clipList[i].title : '-',
            immersion: clipList[i].immersion_index ? clipList[i].immersion_index : '-',
            safety: clipList[i].safety_index ? clipList[i].safety_index : '-',
            length: row.session_type === 'ASYNC' ? async_length : mod_length,
            start: row.session_type === 'ASYNC' ? async_start : mod_start,
            end: row.session_type === 'ASYNC' ? async_end : mod_end,
            safety_tier_indicator: clipList[i].safety_tier_indicator,
            safety_color_indicator: clipList[i].safety_color_indicator,
            safety_context_indicator: clipList[i].safety_context_indicator,
            immersion_color_indicator: clipList[i].immersion_color_indicator,
            immersion_context_indicator: clipList[i].immersion_context_indicator,
            immersion_tier_indicator: clipList[i].immersion_tier_indicator,
            clip_id: clipList[i].clip_id,
          })
        }
      }

      const immersionDetail: any = {
        'Captivated': 0,
        'Absorbed': 0,
        'Interested': 0,
        'Indifferent': 0,
        'Tuned Out': 0
      };

      const immersionBreakup: [] = row.immersion_breakup ? row.immersion_breakup : [];
      for (let i = 0; i < immersionBreakup.length; i++) {
        const item: any = immersionBreakup[i];
        immersionDetail[item['context_indicator']] = Number(item['category_percent']);
      }

      const safetyDetail: any = {
        'Zen': 0,
        'Very Safe': 0,
        'Safe': 0,
        'Unsafe': 0,
        'Very Unsafe': 0
      };

      const safetyBreakup: [] = row.safety_breakup ? row.safety_breakup : [];
      for (let i = 0; i < safetyBreakup.length; i++) {
        const item: any = safetyBreakup[i];
        safetyDetail[item['context_indicator']] = Number(item['category_percent']);
      }

      const objectData: any = {
        session_id: row.session_id,
        project_id: row.project_id,
        session_type: row.session_type,
        session_title: row.session_title,
        session_status: row.session_status,
        session_category: row.session_category,
        session_subcategory: row.session_subcategory,
        participants: row.participantscount ? row.participantscount : 0,
        name: row.session_title,
        immersion: Number(row.immersion_index),
        safety: Number(row.safety_index),
        immersion_color_indicator: row.immersion_color_indicator,
        safety_color_indicator: row.safety_color_indicator,
        start: row.started_at ? row.started_at : row.scheduled_start_at,
        end: row.ended_at ? row.ended_at : row.scheduled_end_at,
        status: row.session_status,
        session_length: row.session_length,
        session_code: row.session_code,
        clips: clips,
        img: row.small_thumbnail ? row.small_thumbnail : '/assets/images/video-processing.png',
        img_large: row.large_thumbnail ? row.large_thumbnail : '/assets/images/video-processing.png',
        user: row.user,
        userColor:"hsl(" + Math.random() * 360 + ", 100%, 75%)",
        stimulus_type: row.stimulus_type,
        stimulus_status: row.stimulus_status ? row.stimulus_status : "",
        project_folders: row.project_folders,
        immersion_detail: immersionDetail,
        safety_detail: safetyDetail,
        saved_benchmark: row.saved_benchmark,
        show_banner: row.show_banner
      };

      if (!addExperience.find((val: any) => val.session_id === row.session_id)) {
        addExperience.push(objectData)
      } else {
        let index: any = '';
        for (let j = 0; j < addExperience.length; j++) {
          if (addExperience[j].session_id === row.session_id) {
            index = j
          }
        }
        if (index !== '') {
          addExperience[index] = objectData
        }
      }
      return objectData;
    });
    setExperiences(addExperience);
  };

  const handleBreadItemClick = (values: any) => {
    dispatch(updateSpecialProject(values.projectId));
    const req = { 
      keyword: "", 
      user_id: [],
      page_no: 1,
      size: PAGINATION_PER_PAGE_ITEM * searchSessionPage,
      clip_page_no: 1,
      clip_page_size: PAGINATION_PER_PAGE_ITEM * searchSessionPage,
      identifier: 'session',
      sort_direction: sort_direction,
      sort_column: sort_column_value
    };
    dispatch(searchExperience(apolloClient.client, req))
  };

  const nextPageData = (type: any) => {
    if (type === 'session') {
      if (searchSessionPage < Math.ceil(searchKey.count / PAGINATION_PER_PAGE_ITEM)) {
        setAllExpChecked(false);
        const request = {
          keyword: searchText, 
          user_id: searchUsers,
          page_no: searchSessionPage + 1,
          size: PAGINATION_PER_PAGE_ITEM,
          clip_page_no: searchClipPage,
          clip_page_size: PAGINATION_PER_PAGE_ITEM,
          identifier: type,
          sort_direction: search_sort_request.sort_direction ? search_sort_request.sort_direction : "",
          sort_column: search_sort_request.sort_column ? search_sort_request.sort_column : "",
        };
        dispatch(searchExperience(apolloClient.client, request));
        setNewSessionPage(searchSessionPage + 1);
        dispatch(updateSearchSessionPage(searchSessionPage + 1));
      }
    } else if (type === 'clip') {
      if (searchClipPage < Math.ceil(searchKey.clips_count / PAGINATION_PER_PAGE_ITEM)) {
        setAllClipsChecked(false);
        const request = {
          keyword: searchText,
          user_id: searchUsers,
          page_no: searchSessionPage,
          size: PAGINATION_PER_PAGE_ITEM,
          clip_page_no: searchClipPage + 1,
          clip_page_size: PAGINATION_PER_PAGE_ITEM,
          identifier: type,
          sort_direction: search_sort_request.sort_direction ? search_sort_request.sort_direction : "",
          sort_column: search_sort_request.sort_column ? search_sort_request.sort_column : "",
        };
        dispatch(searchExperience(apolloClient.client, request));
        setNewClipPage(searchClipPage + 1);
        dispatch(updateSearchClipPage(searchClipPage + 1));
      }
    }
  };

  const selectAllExperiences = useCallback(() => {
    setAllExpChecked(true);
    onSelectAllExperiences(experiences);
  }, [experiences]);

  const selectAllClips = useCallback(() => {
    setAllClipsChecked(true);
    onSelectAllClips(clips);
  }, [clips]);

  const clearAllExperiences = useCallback(() => {
    setAllExpChecked(false);
    onClearExperiences(experiences);
  }, [experiences]);

  const clearAllClips = useCallback(() => {
    setAllClipsChecked(false);
    onClearClips(clips);
  }, [clips]);

  return (
    <div className={classes.container}>
      <p className={classes.title}> {searchKey.count} Experiences and {searchKey.clips_count} Clips Results </p>
      {experiences.length > 0 && (
        <>
          <div className={classes.row} onClick={() => setExperience(!experience)}>
            <p>Experiences ({searchKey.count})</p>
            {experience ? <DownIcon /> : <RightIcon />}
          </div>

          <Collapse in={experience}>
            <div className={classes.subcard}>
              <CreatorTableHeader
                {...props}
                data={userColumn ? CREATOR_TABLE_HEADER_WITH_USER : CREATOR_TABLE_HEADER}
                clipTable={false}
                search={true}
                onSelectAllExperiences={() => selectAllExperiences()}
                onClearExperiences={() => clearAllExperiences()}
                allExpChecked={allExpChecked}
              />
              {
                experiences.map((item: any, index) =>
                  <div
                    key={index}
                    className={clsx(
                      classes.bgfff,
                      item.session_id === open && classes.borderRadius10,
                      index === experiences.length - 1 && classes.borderRadiusBottom,
                      (initialHover === item.session_id && open !== item.session_id) && classes.bg
                    )}
                    onMouseOver={()=>setInitialHover(item.session_id)}
                    onMouseLeave={()=>setInitialHover('')}
                  >
                    <CreatorTableBody
                      HEADER={userColumn ? CREATOR_TABLE_HEADER_WITH_USER : CREATOR_TABLE_HEADER}
                      item={item}
                      userColumn={userColumn}
                      initialHover={initialHover}
                      {...props}
                      search={true}
                      selected={selected}
                      open={open}
                      setOpen={setOpen}
                    />
                    {
                      item.session_id === open &&
                      <div style={{ marginBottom: 22, background: '#E4E9EF' }}>
                        <CreatorTableHeader data={CREATOR_TABLE_SUBHEADER} sub={true} />
                        {
                          item.clips.map((clip: any, k: number) =>
                            <div
                              key={k}
                              onMouseOver={() => setClipRowHover(clip.clip_id)}
                              onMouseLeave={() => setClipRowHover('')}
                            >
                              <CreatorTableSubBody
                                key={k}
                                HEADER={CREATOR_TABLE_SUBHEADER}
                                {...props}
                                clip={clip}
                                selected={selected}
                                disableNavigation={props.disableNavigation}
                                search={true}
                                onChangeSelected={onChangeSelected}
                                open={open}
                                setOpen={setOpen}
                                experienceStart={item.start}
                                hoverIndex={clipRowHover}
                              />
                            </div>)
                        }
                      </div>
                    }
                  </div>)
              }
            </div>
          </Collapse>

          {searchKey.sessions && searchKey.sessions.length > 0 && Math.ceil(searchKey.count / PAGINATION_PER_PAGE_ITEM) !== searchSessionPage  && (
            <div className={classes.loadMoreDiv}>
              {!is_loading && <Button className={classes.loadMoreBtn} onClick={() => nextPageData('session')}>
                Load more...
              </Button>}
              {is_loading && <Loading />}
            </div>
          )}
        </>
      )}
      {clips.length > 0 && (
        <>
          <Box mt={3} className={classes.row} onClick={() => setClip(!clip)}>
            <p>Clips ({clips.length})</p>
            {clip ? <DownIcon /> : <RightIcon />}
          </Box>
          <Collapse in={clip}>
            <div className={classes.subcard}>
              <CreatorTableHeader
                {...props}
                data={CREATOR_CLIP_TABLE_SUBHEADER}
                search={true}
                clipTable={true}
                onSelectAllClips={() => selectAllClips()}
                onClearClips={() => clearAllClips()}
                allClipsChecked={allClipsChecked}
              />
              {
                clips.map((item: any, index) =>
                  <div
                    key={index}
                    onMouseOver={() => setClipRowHover(item.clip_id)}
                    onMouseLeave={() => setClipRowHover('')}
                    className={clsx(
                      classes.bgfff,
                      (clipRowHover === item.clip_id && classes.bg)
                    )}
                  >
                    <CreatorClipTableBody
                      HEADER={CREATOR_CLIP_TABLE_SUBHEADER}
                      clip={item}
                      selected={selected}
                      disableNavigation={props.disableNavigation}
                      search={true}
                      onChangeSelected={onChangeSelected}
                      open={open}
                      setOpen={setOpen}
                      experienceStart={item.start}
                      hoverIndex={clipRowHover}
                      {...props}
                    />
                  </div>
                )}
            </div>
          </Collapse>

          {searchKey.clips && searchKey.clips.length > 0 && Math.ceil(searchKey.clips_count / PAGINATION_PER_PAGE_ITEM) !== searchClipPage  && (
            <div className={classes.loadMoreDiv}>
              {!is_loading && <Button className={classes.loadMoreBtn} onClick={() => nextPageData('clip')}>
                Load more...
              </Button>}
              {is_loading && <Loading />}
            </div>
          )}
        </>
      )}
      {projects.length > 0 && (
        <>
          <Box mt={3} className={classes.row} onClick={() => setProject(!project)}>
            <p>Projects ({projects.length})</p>
            {project ? <DownIcon /> : <RightIcon />}
          </Box>

          <Collapse in={project}>
            <div className={classes.card}>
              {projects.map((item: any, index: number) =>
                <div key={index} className={classes.project} onClick={() => handleBreadItemClick(item)}>
                  <img src={'/assets/icons/creatordashboard/folder-icon.svg'} alt="{icon}" />
                  <span className={classes.name}>{item.projectName}</span>
                </div>)
              }
            </div>
          </Collapse>
        </>
      )}
    </div>
  )
}

export default CreatorResult;



